import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["transformOrigin", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from "react";
import { Animated } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
var fadingScale = {
  entering: {
    opacity: 1,
    transform: "scale(1)"
  },
  entered: {
    opacity: 1,
    transform: "scale(1)"
  },
  exiting: {
    opacity: 0,
    transform: "scale(0)"
  },
  exited: {
    opacity: 0,
    transform: "scale(0)"
  }
};
var FadingScale = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var transformOrigin = _ref.transformOrigin,
      style = _ref.style,
      animatedProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Animated, _objectSpread(_objectSpread({
    animation: fadingScale,
    animatedProperties: "opacity, transform",
    style: _objectSpread({
      transformOrigin: transformOrigin
    }, style)
  }, animatedProps), {}, {
    ref: ref
  }));
});
FadingScale.displayName = "FadingScale";
export default FadingScale;